module.exports = __webpack_public_path__ + "ae1f2ee9d6d126fdbf0e52bc1fe63407.svg";